import { Badge } from '@/components/ui/badge';

export function PreviewBadge() {
  return (
    <Badge
      variant='outline'
      className='bg-teal-50 dark:bg-teal-950 text-teal-700 dark:text-teal-300 border-teal-50 dark:border-teal-950'
    >
      Preview
    </Badge>
  );
}
